module.exports = __webpack_public_path__ + "img/left_3.041e126b.jpg";